import isEmpty from 'lodash-es/isEmpty';
import { INCOME_VERIFICATION } from 'src/utils/constants';
import {
  SelectionCard,
  SelectionCardActions,
  SelectionCardContent,
  SelectionCardText,
  SelectionCardTitle,
} from '@components/SelectionCard';
import { Box } from '@spark-web/box';
import { Divider } from '@spark-web/divider';
import { ExclamationIcon } from '@spark-web/icon';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { BankAccountsList } from './BankAccountsList';
import { BankIncomeSources } from './hooks';

interface OpenBankingIncomeReviewErrorProps {
  onIncomeManualEntry?: () => void;
  bankIncomeSources: BankIncomeSources;
}

export default function OpenBankingIncomeReviewError({
  onIncomeManualEntry,
  bankIncomeSources,
}: OpenBankingIncomeReviewErrorProps) {
  const { IMCOME_SYNC_ERROR_TITLE, IMCOME_SYNC_ERROR_DESCRIPTION, VERIFY_INCOME_MANUALLY } = INCOME_VERIFICATION;
  return (
    <Stack background="secondaryLow" padding="small" borderRadius="medium" gap="small">
      <SelectionCard border="secondary" display="block" paddingY="large">
        <ExclamationIcon size="large" tone="secondary" />
        <SelectionCardContent gap="large">
          <Stack gap="xlarge" marginTop="large">
            <Box>
              <SelectionCardTitle size="large">{IMCOME_SYNC_ERROR_TITLE}</SelectionCardTitle>
            </Box>
            <SelectionCardText size="standard">{IMCOME_SYNC_ERROR_DESCRIPTION}</SelectionCardText>
            <Inline gap="medium" alignY="center">
              <SelectionCardActions onClick={onIncomeManualEntry}>{VERIFY_INCOME_MANUALLY}</SelectionCardActions>
            </Inline>
          </Stack>
          {!isEmpty(bankIncomeSources) && (
            <>
              <Divider />
              <BankAccountsList bankIncomeSources={bankIncomeSources} />
            </>
          )}
        </SelectionCardContent>
      </SelectionCard>
    </Stack>
  );
}
